<template>
  <div class="box">
    <img
      src="../../../../assets/images/bg-top@2x.png"
      alt=""
      class="header-img"
    />
    <div class="content">
      <div class="no_club" v-if="row.club_list.length == 0">
        <div style="height: 3.56rem"></div>
        <div style="margin-bottom:10px ; color:#999; text-align:center" >{{row.user.name}}({{row.user.phone}})</div>
        <div class="create_btn" @click="logout()">切换账号</div>
      </div>
      <div class="club" v-if="row.club_list.length > 0">
        <h1>{{ row.club.name }}</h1>
        <div class="level">
          <h1>俱乐部等级</h1>
          <img
            v-if="row.club.bgrade == '一星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '二星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '二星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '三星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '三星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '三星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '四星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
          <img
            v-if="row.club.bgrade == '五星'"
            src="../../../../assets/images/icon-yixiji@2x.png"
            alt=""
          />
        </div> 
        <div style="margin-top:10px ; color:#999" @click="logout()">{{row.user.name}}({{row.user.phone}}) [切换账号]</div>
        <div class="br" style="margin-top: 0.4rem"></div> 
        <div style="display: flex; justify-content: space-between;flex-wrap: wrap;">
          <div class="btn"  @click.stop="sheetActiveShow=true">切换俱乐部</div>
          <div class="btn" @click="goClubGrade()">俱乐部升级</div> 
          <div class="btn"  @click.stop="goDakejian()">申报大课间</div>
          <div class="btn"   @click.stop="goSihao()">四好运动员</div>
        </div>
      </div>


      <div style="margin: 50px auto;" v-if="row.club_list.length == 0" class="btn"   @click.stop="goSihao()">四好运动员申报</div>

      <!-- <div
              class="no_grade"
              style="margin-top: 0.3rem"
              v-if="row.danwei_list.length == 0"
            >
              <div style="height: 3.56rem"></div> 
            </div>
            <div
        class="club"
        style="margin-top: 0.3rem"
        v-if="row.danwei_list.length > 0"
      >
        <h1>{{ row.danwei.name }}</h1> 
        <div style="display: flex; justify-content: space-between"> 
          <div class="btn" 
            v-if="row.danwei_list.length > 1" @click.stop="sheetDanweiActiveShow=true">切换单位</div>
          <div class="btn" v-show="showClubDakejian" @click.stop="goDakejian()">申报大课间</div>
        </div>
      </div> -->

    </div> 
    <van-action-sheet
      v-model="sheetActiveShow"
      description="将以新的俱乐部主体参赛报名"
      :actions="row.club_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSelect"
    />

    <van-action-sheet
      v-model="sheetDanweiActiveShow"
      description="将以新的单位为主体参赛报名"
      :actions="row.danwei_list"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onDanweiSelect"
    /> 


    <LoginDialog
      :show="loginShow"
      @loginSuccess="loginSuccess"
      @loginCancel="loginCancel"
    />
  </div>
</template>
<style scoped>
.box {
  height: 100%;
  overflow: scroll;
  padding-bottom: 2rem;
  background: #f0eff4;
}
.content {
  padding: 0.2rem;
  padding-top: 0.3rem;
}
.header-img {
  width: 100%;
  height: 2.76rem;
}
.club {
  /* height: 5.1rem; */
  background: #ffffff;
  border-radius: 10px;
  position: relative;
  top: -0.8rem;
  padding: 0.3rem;
}
.club h1 {
  font-size: 0.42rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #191919;
  line-height: 0.6rem;
}
.level {
  display: flex;
  margin-top: 0.1rem;
}
.level h1 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.4rem;
}
.level img {
  width: 0.4rem;
  height: 0.4rem;
  margin-left: 0.1rem;
}
.br {
  height: 1px;
  background: #ebedf0;
  margin-top: 0.2rem;
}
.club h2 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
  margin-top: 0.4rem;
}
.club_detail {
  display: flex;
  text-align: center;
  justify-content: space-between;
  margin-top: 0.4rem;
  padding-left: 0.16rem;
}
.detail_info h1 {
  font-size: 0.42rem;
  font-family: DINCond-Black, DINCond;
  font-weight: 900;
  color: #333333;
  line-height: 0.5rem;
}
.detail_info h2 {
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.34rem;
  margin-top: 0.08rem;
}
.btn {
  width: 40%;
  height: 0.64rem;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.64rem;
  text-align: center;
  margin-top: 0.4rem;
}
.icon {
  width: 1.32rem;
  height: 0.42rem;
  background: linear-gradient(270deg, #f4faff 0%, #84caff 100%);
  border-radius: 11px;
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.42rem;
  text-align: center;
  margin-top: 0.12rem;
}
.no_club {
  height: 4.72rem;
  background-image: url("../../../../assets/images/bg-weijiarujulebu@2x.png");
  background-size: 100% 100%;
}
.create_btn {
  width: 86px;
  height: 32px;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 23px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 32px;
  text-align: center;
  margin: 0 auto;
}
.no_grade {
  height: 4.72rem;
  background-image: url("../../../../assets/images/bg-weijiarukaoji@2x.png");
  background-size: 100% 100%;
}
.dialog-head {
  font-size: 0.5rem;
  font-weight: 700;
  text-align: center;
  padding: 0.4rem 0 0.3rem;
}

.dialog-content {
  padding: 0 0.3rem;
  font-size: 14px;
}

.dialog-content >>> .van-button {
  line-height: 1.2;
  font-size: 14px;
}

.dialog-li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dialog-step-li {
  margin: 0.2rem 0 0.3rem;
}

.dialog-step-li-text {
  color: #409eff;
  margin-top: 3px;
}

.bottom-button {
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}
.my_detail h2 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.4rem;
}
.list_header {
  display: flex;
  justify-content: space-between;
  margin-top: 0.3rem;
}
.list_header h1 {
  font-size: 0.28rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 0.4rem;
  margin-left: 0.3rem;
  line-height: 28px;
}
.action_btn {
  width: 1.36rem;
  height: 0.56rem;
  background: linear-gradient(316deg, #f8d77f 0%, #fcab15 100%);
  border-radius: 0.46rem;
  font-size: 0.24rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.56rem;
  text-align: center;
  margin-right: 0.3rem;
}
</style>
<script>
import Vue from "vue";
// import area from "../../../utils/area";
// import validator from "../../../utils/validator";
import PicUploader from "@/components/picker/PicUploader.vue";
import LoginDialog from "@/components/LoginDialog.vue";

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
} from "vant";

Vue.use(Cell)
  .use(CellGroup)
  .use(Form)
  .use(Dialog)
  .use(Divider)
  .use(Area)
  .use(RadioGroup)
  .use(Radio)
  .use(Icon)
  .use(Toast)
  .use(Popup)
  .use(Picker)
  .use(Sidebar)
  .use(SidebarItem)
  .use(Tag)
  .use(Stepper)
  .use(Field)
  .use(Switch)
  .use(Button);
export default {
  name: "MyClub",
  components: {
    PicUploader,
    LoginDialog,
  },
  data: function () {
    return {
      loading: true,
       sheetActiveShow:false, 
       sheetDanweiActiveShow:false,  
      saveLoading: false,
      loginShow: false,
      showArea: false,
      areaList: {},
      areaValue: "",
      clubShow: false,
      kaojiShow: false,
      showClubDakejian: false,
      submitType: "",
      row: {
        club_list:[],
        center_list:[],
        danwei: {},
        danwei_list:[],
        cert: {},
        setting:{},
        user:[

        ]
      },
      formData: {},
      max1: 2,
      max2: 2,
      max3: 2,
      max1show: true,
      max2show: true,
      max3show: true,
    };
  },
  filters: {},
  mounted() {
    document.title = "我的俱乐部";
    let that = this;
    this.fetch();
  },
  watch: {},
  destroyed() {},
  methods: {
    onQuestion() {
      console.log("onQuestion");
    },
    checkDakejian(){
      let that = this;
      that.$api.post(
        "/api/cdakejian/checkdanweishoupai",
        {
          danwei: that.row.club.shenbaodanwei,
        },
        (res) => {
          that.showClubDakejian = false;
        },
        (res) => {
          that.showClubDakejian = true;
          }
      );

    },
    toJiaolian() {
      if (this.row.cert.status) {
        rbLink({
          name: "UserSearchJiaolian",
        });
      } else {
        Toast("请先进行实名认证");
        setTimeout(function () {
          rbLink({
            name: "CertIndex",
          });
        }, 200);
      }
    },
    unbindClub() {
      let that = this;
      Dialog.confirm({
        title: "确认",
        message: "确认要解除绑定该俱乐部吗?",
      })
        .then(() => {
          that.$api.post(
            "/api/club/clubUserUnBind",
            {
              club_id: that.row.club.id,
            },
            (res) => {
              that.fetch();
            },
            (res) => {}
          );

          //                    that.onPaySuccess();
        })
        .catch(() => {
          //                    that.onPayError();
        });
    },
    unbindCenter() {
      let that = this;
      Dialog.confirm({
        title: "确认",
        message: "确认要解除绑定该考级中心/点吗?",
      })
        .then(() => {
          that.$api.post(
            "/api/examecenter/centerUserUnBind",
            {
              center_id: that.row.center.id,
            },
            (res) => {
              that.fetch();
            },
            (res) => {}
          );

          //                    that.onPaySuccess();
        })
        .catch(() => {
          //                    that.onPayError();
        });
    },
    // 解绑
    unbind() {
      let that = this;

      Dialog.confirm({
        title: "解绑",
        message: "确定解绑吗?",
      })
        .then(() => {
          // on confirm
          that.$api.get(
            "/api/club/clubUserUnBind",
            {
              club_id: that.row.id,
            },
            (res) => {
              Toast.success("解绑成功");
              rbLink(
                {
                  name: "ClubSearchIndex",
                },
                "back"
              );
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    },
    max1change() {
      this.max1 = 10000;
      this.max1show = false;
    },
    max2change() {
      this.max2 = 10000;
      this.max2show = false;
    },
    max3change() {
      this.max3 = 10000;
      this.max3show = false;
    },
    toClub() {
      this.clubShow = true;
    },

    toKaoji() {
      this.kaojiShow = true;
    },

    toCaipan() {
      if (this.row.cert.status) {
        rbLink({
          name: "UserSearchCaipan",
        });
      } else {
        Toast("请先进行实名认证");
        setTimeout(function () {
          rbLink({
            name: "CertIndex",
          });
        }, 200);
      }
    },
    fetch() {
      let that = this;
      that.$api.get(
        "/api/user/myclub",
        {},
        (res) => {
          that.row.club = res.data.club;
          that.row.user = res.data.user;
          that.row.setting = res.data.setting;
          that.row.club_list = res.data.club_list;
          that.loading = false;
          that.checkDakejian()
        },
        (res) => {
          that.loading = false;
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            } 
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );


      // that.$api.post(
      //   "/api/user/certindex",
      //   {},
      //   (res) => {
      //     that.row.danwei = res.data.danwei;
      //     that.row.danwei_list = res.data.danwei_list;
      //   },
      //   (res) => {
      //     console.log("errrrrr");
      //     if (res.code == 401 || res.code == 402) {
      //       if (window.isApp()) {
      //         rbLink(
      //           {
      //             name: "login",
      //             query: {},
      //           },
      //           "replace"
      //         );
      //         return false;
      //       }
      //       that.loginShow = true;
      //     } else {
      //       Toast(res.msg);
      //     }
      //   }
      // );
    },
    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    // 创建俱乐部
    toClubNext(id) {
      // rbLink({
      //   name: "ClubApplyMine",
      //   query: {
      //     id: id,
      //   },
      // });
    },

    // 创建考级中心/点
    toKaojiNext(id) {
      rbLink({
        name: "QcxjStationApplyMine",
        query: {
          id: id,
        },
      });
    },
    // 官网已有考级中心认证
    toAuth() {
      rbLink({
        name: "QcxjStationBind",
      });
    },
    // 下载附件
    download(name, url) {
      appEvent({
        name: "downloadFile",
        query: {
          name: name,
          url: url,
        },
      });
    },
     goClubGrade(){
      if(this.row.setting.club_is_open!=1){
          Toast('申报通道已关闭。'+ this.row.setting.club_is_open_desc+'');
          return
      }

      rbLink({name:'ClubHighApply', query: {id: this.row.club.id}});
    },
    goDakejian(){
      if(this.row.setting.dakejian_is_open!=1){
          Toast('申报通道已关闭。'+ this.row.setting.dakejian_is_open_desc+'');
          return
      }
      rbLink({name:'DakejianList', query: {}});
    },
    goSihao(){
      if(this.row.setting.sihao_is_open!=1){
          Toast('申报通道已关闭。'+ this.row.setting.sihao_is_open_desc+'');
          return
      }
      rbLink({name:'ClubDetailSihao', query: {}});
    },
    onSelect(action,index){
      console.log(action,index)   
      let that = this;
      that.$api.post('/api/club/clubChange', {
        club_id  : action.id
      }, (res) => { 
          Toast('您的俱乐部已切换成【'+ action.name+'】'); 
          that.fetch();
      }, (res) => { 
      })
    },
 

    logout(){ 
      let that = this;
      Dialog.confirm({
        title: "确认",
        message: "您确定要退出登录吗?",
      })
        .then(() => {
            localStorage.removeItem('_token');
            this.$api.get('/api/index/logout',{},r=>{
            location.reload();
            });
          //                    that.onPaySuccess();
        })
        .catch(() => {
          //                    that.onPayError();
        });
 


    },
    onDanweiSelect(action, index) {
      console.log(action, index);
      let that = this;
      that.$api.post(
        "/api/user/danweiChange",
        {
          danwei_id: action.id,
        },
        (res) => {
          Toast("您的备案单位已切换成【" + action.name + "】");
          that.fetch();
        },
        (res) => {}
      );
    },
    onSheetCancel() {
      // Toast('取消');
    },
  },
};
</script>



// WEBPACK FOOTER //
// ClubDakejianSihao.vue?15de9736